import placeholderImage from '../images/placeholder.webp';

const SpeakerCard = ({ speaker, onRemove }) => {
    return (
        <div className="speaker-card">
            {onRemove ? (
                <button className="speaker-remove" onClick={() => onRemove(speaker.id)}>
                    {'\u00D7'}
                </button>
            ) : null}
            <img src={speaker.imageUrl ? process.env.REACT_APP_MEDIA_URL + speaker.imageUrl : placeholderImage} alt={speaker.firstName + ' ' + speaker.lastName} />
            <div className="speaker-info">
                <div className="speaker-name">{speaker.firstName} {speaker.lastName}</div>
            </div>
        </div>
    );
}

export default SpeakerCard;